import React, {PropTypes} from 'react';

class NavBtn extends React.PureComponent {
  render() {
    return(
      <button className={"nav-btn btn " + this.props.toggle} href="#"
        onClick={(e) => this.props.onClick(e)} data-value="nav"/>
    );
  }
}

NavBtn.propTypes = {
  onClick: PropTypes.func,
  toggle: PropTypes.string
};

export default NavBtn;




/** WEBPACK FOOTER **
 ** ./src/components/nav/NavBtn.js
 **/